/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, CardContent, Typography, Button, Skeleton } from "@mui/material";
import { useTheme } from "../../style/theme";
import Image from "../Image";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";

const cardData = [
  {
    title: "Clikkle Ads",
    organization: "Rakesh Corp",
    icon: "ads/logo/2023/ads.png",
    route: "/subscription/hr/purchase",
  },
  {
    title: "Clikkle Campaigns",
    organization: "Rakesh Corp",
    icon: "campaigns/logo/2025/clikkle%20campaigns.png",
    route: "/subscription/hr/purchase",
  },
  {
    title: "Clikkle CRM",
    organization: "Rakesh Corp",
    icon: "crm/2025/clikkle%20crm.png",
    route: "/subscription/hr/purchase",
  },
  {
    title: "Clikkle E-sign",
    organization: "Rakesh Corp",
    icon: "e-sign/logo/2025/clikkle%20esign.png",
    route: "/subscription/files/purchase",
  },
  {
    title: "Clikkle Host",
    organization: "Rakesh Corp",
    icon: "host/logo/2023/host.png",
    route: "/subscription/E-Sign/purchase",
  },
  {
    title: "Clikkle HR",
    organization: "Rakesh Corp",
    icon: "hr/logo/2025/clikkle%20hr.png",
    route: "/subscription/hr/purchase",
  },
  {
    title: "Clikkle Launch",
    organization: "Rakesh Corp",
    icon: "launch/logo/2023/launch.png",
    route: "/subscription/Projects/purchase",
  },
  {
    title: "Clikkle Mail",
    organization: "Rakesh Corp",
    icon: "cmail/logo/2023/cmail.png",
    route: "/subscription/hr/purchase",
  },
  {
    title: "Clikkle Pitch",
    organization: "Rakesh Corp",
    icon: "pitch/logo/2023/pitch.png",
    route: "/subscription/hr/purchase",
  },
  // {
  //   title: "Clikkle Projects",
  //   organization: "Rakesh Corp",
  //   icon: "projects/logo/2025/clikkle%20projects.png",
  //   route: "/subscription/hr/purchase",
  // },
];

const Unused = () => {
  const [loading, setLoading] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const platformUser = useUser();

  const getOrganizations = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/store/organization?userId=${platformUser?._id}`
      );
      const fetchedOrganizations = response?.data?.data;
      setOrganizations(fetchedOrganizations);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getOrganizations();
  }, []);

  const { mode } = useTheme();

  return (
    <Box
      sx={{
        paddingBottom: { xs: "60px", sm: "20px" },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
          mt: 1.5,
          ml: 1,
        }}
      >
        {loading
          ? Array.from({ length: 3 }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                  border: `1px solid ${
                    mode === "light" ? "#DFDFDF" : "#2E2E2E"
                  }`,
                  borderRadius: "12px",
                  width: "100%",
                  px: 2,
                  py: 2,
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                      flexDirection: "row",
                      flexWrap: "nowrap",
                    }}
                  >
                    {/* Skeleton Icon Box */}
                    <Skeleton
                      variant="rectangular"
                      width={110}
                      height={110}
                      sx={{
                        borderRadius: "8px",
                        flexShrink: 0,
                      }}
                    />

                    {/* Skeleton Text and Button */}
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: {
                          xs: "row",
                          sm: "column",
                        },
                        justifyContent: {
                          xs: "space-between",
                          sm: "center",
                        },
                        alignItems: {
                          xs: "center",
                          sm: "flex-start",
                        },
                        gap: 1,
                      }}
                    >
                      <Skeleton
                        variant="text"
                        width={120}
                        height={28}
                        sx={{ borderRadius: 2 }}
                      />
                      <Skeleton
                        variant="rectangular"
                        width={100}
                        height={36}
                        sx={{ borderRadius: 2 }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Box>
            ))
          : cardData.map((service, index) => {
              if (service.title === "Clikkle HR" && organizations.length > 0) {
                return null;
              }

              return (
                <Box
                  key={index}
                  sx={{
                    backgroundColor: mode === "light" ? "#fff" : "#141414",
                    border: `1px solid ${
                      mode === "light" ? "#DFDFDF" : "#2E2E2E"
                    }`,
                    borderRadius: "12px",
                    width: "100%",
                    px: 2,
                    py: 0.2,
                  }}
                >
                  <CardContent sx={{ p: 0 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                        flexDirection: "row",
                        flexWrap: "nowrap",
                      }}
                    >
                      {/* Icon Box */}
                      <Box
                        sx={{
                          width: { xs: 65, sm: 130 },
                          height: { xs: 65, sm: 100 },
                          borderRadius: "8px",
                          border: `1px solid ${
                            mode === "light" ? "#d1d5db" : "#2E2E2E"
                          }`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: { xs: "20px", sm: "10px" },
                        }}
                      >
                        <Image
                          cdn={service.icon}
                          alt={`${service.title} Icon`}
                          style={{
                            width: "75%",
                            height: "75%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>

                      {/* Title + Button */}
                      <Box
                        sx={{
                          display: "flex",
                          width: "100%",
                          height: "100%",
                          flexDirection: {
                            xs: "row",
                            sm: "column",
                          },
                          justifyContent: {
                            xs: "space-between",
                            sm: "center",
                          },
                          alignItems: {
                            xs: "center",
                            sm: "start",
                          },
                          gap: 1,
                          marginTop: { xs: "20px", sm: "10px" },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: { xs: 400, sm: 500 },
                            fontSize: { xs: "1.2rem", sm: "1.7rem" },
                            color: mode === "light" ? "#000" : "#fff",
                          }}
                        >
                          {service.title}
                        </Typography>

                        <Button
                          variant="contained"
                          sx={{
                            width: "fit-content",
                            fontSize: { xs: "0.85rem", sm: "1.0rem" },
                            padding: { xs: "6px 18px", sm: "6px 25px" },
                            textTransform: "none",
                            backgroundColor: "#007BFF",
                            borderRadius: "8px",
                            ":hover": {
                              backgroundColor: "#156edc",
                            },
                          }}
                        >
                          Access
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Box>
              );
            })}
      </Box>
    </Box>
  );
};

export default Unused;
